module.exports = __webpack_public_path__ + "static/alert-link-do-3443147ecd7b297534a23e15e673599e.png";